(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('AccountClearingRequestDetailController', AccountClearingRequestDetailController);

    AccountClearingRequestDetailController.$inject = ['$stateParams', 'AccountClearingRequest', 'CompanyPaymentLogCustom'];

    function AccountClearingRequestDetailController($stateParams, AccountClearingRequest, CompanyPaymentLogCustom) {
        var vm = this;
        vm.accountClearingRequest = null;
        vm.findStatusStyle = findStatusStyle;
        vm.findStatusIcon = findStatusIcon;

        loadData();

        function loadData() {
            AccountClearingRequest.get({id: $stateParams.id}).$promise.then(function (result) {

                vm.accountClearingRequest = result;
            });

            vm.companyPaymentLogs = CompanyPaymentLogCustom.getCompanyPaymentLogsByAccountClearingRequestId($stateParams.id).query(function (result) {
                vm.companyPaymentLogs = result;
            });

        }


        function findStatusStyle(status) {
            return "account-clearing-request-status-" + status;
        }

        function findStatusIcon(status) {
            if (status == "REQUESTED") {
                return "glyphicon glyphicon-hourglass";
            }
            if (status == "DONE") {
                return "glyphicon glyphicon-ok";
            }
            if (status == "UNDERWAY") {
                return "glyphicon glyphicon-eye-open";
            }

        }


    }
})();
